import React from 'react';
import Landing from './components/landing/Landing'
import TOS from './components/Home/TOS'
import Privacy from './components/Home/Privacy'
import Template from './components/Templates/Template'
import {
  Switch,
  Route,
} from "react-router-dom";
import { MyRequests, Appointments, Opportunities, PostShowingPage, ShowingsRedirect } from './components/dashboard/pages';
import ShowingsMap from './components/dashboard/ShowingsMap';
import Reviews from './components/dashboard/Reviews';
import CompleteProfile from './components/forms/complete-profile';
import ResetPassword from './components/login/ResetPassword';
import VerifyEmail from './components/login/VerifyEmail';
import { PrivateRoute } from './components/Templates/PrivateRoute'
import { userService } from './_services/user.service';
import AdminDashboard from './components/admin/AdminDashboard'
import AdminLicenses from './components/admin/AdminLicenses'
import Profile from './components/profile/Profile';

class App extends React.Component {

  componentDidMount() {
    userService.loadUserInfo()
  }

  render() {
    return (
      <div>
        <Switch>
          <Route exact path="/" component={Landing} />
          <Route exact path="/complete-profile" component={CompleteProfile} />
          <Route exact path="/reset-password" component={ResetPassword} />
          <Route exact path="/verify-email" component={VerifyEmail} />

          <Template>
            <Switch>

              <PrivateRoute exact path="/users/profile/" component={Profile} />
              <PrivateRoute exact path="/showings/post" component={PostShowingPage} />
              <PrivateRoute exact path="/showings/requests" component={MyRequests} />
              <PrivateRoute exact path="/showings/appointments" component={Appointments} />
              <PrivateRoute exact path="/showings" component={ShowingsRedirect} />
              <PrivateRoute exact path="/jobs" component={Opportunities} />
              <PrivateRoute exact path="/map" component={ShowingsMap} />
              <PrivateRoute exact path="/reviews" component={Reviews} />
              <PrivateRoute exact path="/admin" component={AdminDashboard} />
              <PrivateRoute exact path="/admin/licenses" component={AdminLicenses} />
              <Route exact path="/tos" component={TOS} />
              <Route exact path="/privacy" component={Privacy} />

            </Switch>
          </Template>

        </Switch>

      </div>)
  }
}

export default App;
